import React from "react";

function PushNotificationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99967 11.9997H8.00634M4.66634 1.33301H11.333C12.0694 1.33301 12.6663 1.92996 12.6663 2.66634V13.333C12.6663 14.0694 12.0694 14.6663 11.333 14.6663H4.66634C3.92996 14.6663 3.33301 14.0694 3.33301 13.333V2.66634C3.33301 1.92996 3.92996 1.33301 4.66634 1.33301Z"
        stroke="black"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default PushNotificationIcon;
